import { useEffect, useState } from 'react';
import axios from 'axios';

import type { UrpsConfig } from '@tn-types/cloud-common-accesscontrol';


function getUrpsConfigUrl(): string {
    let loc = `${window.location.origin}${window.location.pathname}`;

    if (!loc.endsWith('/')) {
        loc += '/';
    }

    loc += 'urps-config.json';

    return loc;
};

export function useUrpsConfigRequest() {
    const url = getUrpsConfigUrl();

    const [urpsConfig, setConfig] = useState<UrpsConfig | null>(null);
    const [error, setError] = useState<unknown>(null);

    useEffect(() => {
        const controller = new AbortController();

        const fetchConfig = async () => {
            try {
                const res = await axios.get<UrpsConfig>(url, {
                    signal: controller.signal,
                });

                setConfig(res.data);
            } catch (err) {
                if (controller.signal.aborted) return; 
                setError(err);
            }
        };

        fetchConfig();

        return () => {
            controller.abort();
        };
    }, [url]);

    return {
        urpsConfig: urpsConfig,
        error,
        loading: urpsConfig === null && error === null
    };
};

export default useUrpsConfigRequest;